import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React, { Fragment, useEffect, useState } from "react";
import Button from "../components/Button";
import MyLink from "../components/Link";
import useWindowSize from "../useWindowSize";
import { stickyNav } from "../utils";
import MobileHeader from "./MobileHeader";
import OffcanvasPanel from "./OffcanvasPanel";
import Top from "./Top";

const Menu = ({ list }) => (
  <nav className="main-menu d-none d-xl-block">
    <ul>
      {list?.map((item, index) => {
        return (
          <li
            className={`menu-item ${
              item.childMenu.length > 0 ? "has-children" : ""
            } `}
            key={index}
          >
            {item.childMenu.length > 0 ? (
              <>
                <MyLink
                  link={item.parent.link}
                  linkType={item.parent.type}
                  text={item.parent.label}
                  iconLeft={false}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="ml-2"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M6 9l6 6l6 -6" />
                  </svg>
                </MyLink>

                <ul className="sub-menu">
                  {item.childMenu.map((child, ind) => (
                    <li key={ind}>
                      <MyLink
                        link={child.link}
                        linkType={child.type}
                        text={child.label}
                      />
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <MyLink
                link={item.parent.link}
                linkType={item.parent.type}
                text={item.parent.label}
              />
            )}
          </li>
        );
      })}
    </ul>
  </nav>
);

const Header = ({ header, topBanner, data }) => {
  useEffect(() => {
    stickyNav();
  }, []);
  const [overlayPanel, setOverlayPanel] = useState(false);
  const togglePanel = () => setOverlayPanel(!overlayPanel);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { width } = useWindowSize();

  useEffect(() => {
    const headers = document.querySelectorAll(".header-navigation");
    headers.forEach((headerEl) => {
      if (width <= 1199) {
        setIsMobile(true);
        headerEl.classList.add("breakpoint-on");
      } else {
        setIsMobile(false);
        setMobileMenuOpen(false);
        headerEl.classList.remove("breakpoint-on");
      }
    });
  }, [width]);

  const toggleMobileMenu = (e) => {
    if (e) e.preventDefault();
    setMobileMenuOpen((prev) => !prev);
  };
  const closeMobileMenu = () => setMobileMenuOpen(false);

  const mobileMenuProps = {
    mobileMenuOpen,
    onToggleMobileMenu: toggleMobileMenu,
    onCloseMobileMenu: closeMobileMenu,
  };

  switch (header) {
    case 1:
      return <Header1 {...mobileMenuProps} />;
    case 2:
      return <Header2 {...mobileMenuProps} />;
    case 3:
      return (
        <Header3
          overlayPanel={overlayPanel}
          togglePanel={() => togglePanel()}
          {...mobileMenuProps}
        />
      );
    case 4:
      return (
        <Header4
          overlayPanel={overlayPanel}
          togglePanel={() => togglePanel()}
          data={data}
          topBanner={topBanner}
          {...mobileMenuProps}
        />
      );
    default:
      return (
        <DefaultHeader
          data={data}
          topBanner={topBanner}
          isMobile={isMobile}
          {...mobileMenuProps}
        />
      );
  }
};
export default Header;

const Header1 = ({ mobileMenuOpen, onToggleMobileMenu, onCloseMobileMenu }) => (
  <header className="header-area">
    <div className="header-top-bar top-bar-one dark-black-bg">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-12 col-md-12 col-6">
            <div className="top-bar-left d-flex align-items-center">
              <span className="text">
                Welcome to Agriculture &amp; Organic Food Template
              </span>
              {/* <span className="lang-dropdown">
                <select className="wide">
                  <option value={1}>English</option>
                  <option value={2}>French</option>
                </select>
              </span> */}
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-6">
            <div className="top-bar-right">
              <span className="text">
                <i className="far fa-clock" />
                Opening Hours : Sunday- Friday, 08:00 am - 05:00pm
              </span>
              <ul className="social-link">
                <li>
                  <a href="#" title="Facebook">
                    {/* <i className="fab fa-facebook-f" /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      class="icon icon-tabler icons-tabler-outline icon-tabler-brand-facebook"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#" title="X">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="#" title="Linkedin">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a href="#" title="Youtube">
                    <i className="fab fa-youtube" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="header-middle">
      <div className="container-1350">
        <div className="row align-items-center">
          <div className="col-xl-4 d-xl-block d-lg-none">
            <div className="site-branding d-lg-block d-none">
              <Link to="/" className="brand-logo" aria-label="brand-logo">
                <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
              </Link>
            </div>
          </div>
          <div className="col-xl-8 col-lg-12">
            <div className="contact-information">
              <div className="information-item_one d-flex">
                <div className="icon">
                  <i className="flaticon-placeholder" />
                </div>
                <div className="info">
                  <h5 className="mb-1">Locations</h5>
                  <p>55 Main Street, New York</p>
                </div>
              </div>
              <div className="information-item_one d-flex">
                <div className="icon">
                  <i className="flaticon-email" />
                </div>
                <div className="info">
                  <h5 className="mb-1">Email Us</h5>
                  <p>
                    <a href="mailto:tjs@civsav.com">tjs@civsav.com</a>
                  </p>
                </div>
              </div>
              <div className="button text-md-right text-sm-center">
                <Link to="/contact">
                  <a className="main-btn btn-yellow">Get a Quote</a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="header-navigation navigation-one">
      <div
        className={`nav-overlay ${mobileMenuOpen ? "active" : ""}`}
        aria-hidden="true"
        onClick={onCloseMobileMenu}
      />
      <div className="container-1350">
        <div className="primary-menu">
          <div className="site-branding">
            <Link to="/" className="brand-logo" aria-label="brand-logo">
              <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
            </Link>
          </div>
          <div className="nav-inner-menu">
            <div className={`nav-menu ${mobileMenuOpen ? "menu-on" : ""}`} id="main-nav-menu" role="navigation" aria-label="Main">
              {/*=== Mobile Logo ===*/}
              <div className="mobile-logo mb-30 d-block d-xl-none text-center" onClick={onCloseMobileMenu}>
                <Link to="/" className="brand-logo" aria-label="brand-logo">
                  <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
                </Link>
              </div>
              {/*=== Main Menu ===*/}
              <Menu />
              <MobileHeader />
            </div>
            {/*=== Nav Right Item ===*/}
            <div className="nav-right-item">
              <button
                type="button"
                className="navbar-toggler"
                aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                aria-expanded={mobileMenuOpen}
                aria-controls="main-nav-menu"
                onClick={onToggleMobileMenu}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

const Header2 = ({ mobileMenuOpen, onToggleMobileMenu, onCloseMobileMenu }) => (
  <header className="header-area">
    <div className="header-top-bar top-bar-one dark-black-bg">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-12 col-md-12 col-6">
            <div className="top-bar-left d-flex align-items-center">
              <span className="text">
                Welcome to Agriculture &amp; Organic Food Template
              </span>
              {/* <span className="lang-dropdown">
                <select className="wide">
                  <option value={1}>English</option>
                  <option value={2}>French</option>
                </select>
              </span> */}
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-6">
            <div className="top-bar-right">
              <span className="text">
                <i className="far fa-clock" />
                Opening Hours : Sunday- Friday, 08:00 am - 05:00pm
              </span>
              <ul className="social-link">
                <li>
                  <a href="#" title="Facebook">
                    {/* <i className="fab fa-facebook-f" /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
                    </svg>
                  </a>
                </li>
                <li>
                  <a href="#" title="X">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
                <li>
                  <a href="#" title="Linkedin">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a href="#" title="Youtube">
                    <i className="fab fa-youtube" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="header-navigation navigation-two">
      <div
        className={`nav-overlay ${mobileMenuOpen ? "active" : ""}`}
        aria-hidden="true"
        onClick={onCloseMobileMenu}
      />
      <div className="container-fluid">
        <div className="primary-menu">
          <div className="site-branding">
            <Link to="/" className="brand-logo" aria-label="brand-logo">
              <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
            </Link>
          </div>
          <div className="nav-inner-menu">
            <div className={`nav-menu ${mobileMenuOpen ? "menu-on" : ""}`} id="main-nav-menu" role="navigation" aria-label="Main">
              {/*=== Mobile Logo ===*/}
              <div className="mobile-logo mb-30 d-block d-xl-none text-center" onClick={onCloseMobileMenu}>
                <Link to="/" className="brand-logo" aria-label="brand-logo">
                  <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
                </Link>
              </div>
              {/*=== Navbar Call Button ===*/}
              <div className="call-button text-center">
                <span>
                  <i className="far fa-phone" />
                  <a to="tel:+012(345)678">+012 (345) 678</a>
                </span>
              </div>
              {/*=== Main Menu ===*/}
              <Menu />
              <MobileHeader />
              {/*=== Navbar Menu Button ===*/}
              <div className="menu-button">
                <Link to="/contact">
                  <a className="main-btn btn-yellow">Get a Quote</a>
                </Link>
              </div>
            </div>
            {/*=== nav Right Item ===*/}
            <div className="nav-right-item d-flex align-items-center">
              <div className="call-button">
                <span>
                  <i className="far fa-phone" />
                  <a href="tel:+012(345)678">+012 (345) 678</a>
                </span>
              </div>
              <div className="menu-button">
                <Link to="/contact">
                  <a className="main-btn btn-yellow">Get a Quote</a>
                </Link>
              </div>
              <button
                type="button"
                className="navbar-toggler"
                aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                aria-expanded={mobileMenuOpen}
                aria-controls="main-nav-menu"
                onClick={onToggleMobileMenu}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);

const Header3 = ({ overlayPanel, togglePanel, mobileMenuOpen, onToggleMobileMenu, onCloseMobileMenu }) => (
  <Fragment>
    <OffcanvasPanel overlyPanel={overlayPanel} togglePanel={togglePanel} />
    <header className="header-area">
      {/* Header Navigation */}
      <div className="header-navigation navigation-three">
        <div
          className={`nav-overlay ${mobileMenuOpen ? "active" : ""}`}
          aria-hidden="true"
          onClick={onCloseMobileMenu}
        />
        <div className="container-fluid">
          <div className="primary-menu">
            {/* Site Branding */}
            <div className="site-branding">
              <Link to="/" className="brand-logo" aria-label="brand-logo">
                <img src="/assets/images/logo/logo-3.png" alt="Site Logo" />
              </Link>
              <Link to="/">
                <a className="sticky-logo">
                  <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
                </a>
              </Link>
            </div>
            {/* Nav inner Menu */}
            <div className="nav-inner-menu">
              {/* Nav Menu */}
              <div className={`nav-menu ${mobileMenuOpen ? "menu-on" : ""}`} id="main-nav-menu" role="navigation" aria-label="Main">
                {/*=== Mobile Logo ===*/}
                <div className="mobile-logo mb-30 d-block d-xl-none text-center" onClick={onCloseMobileMenu}>
                  <Link to="/" className="brand-logo" aria-label="brand-logo">
                    <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
                  </Link>
                </div>
                {/*=== Navbar Call Button ===*/}
                <div className="call-button text-center">
                  <span>
                    <i className="far fa-phone" />
                    <a href="tel:+012(345)678">+012 (345) 678</a>
                  </span>
                </div>
                {/*=== Main Menu ===*/}
                <Menu />
                <MobileHeader />
                {/*=== Navbar Menu Button ===*/}
                <div className="menu-button">
                  <Link to="/contact">
                    <a className="main-btn btn-yellow">Get a Quote</a>
                  </Link>
                </div>
              </div>
              {/*=== Nav Right Item ===*/}
              <div className="nav-right-item d-flex align-items-center">
                <div className="call-button">
                  <span>
                    <i className="far fa-phone" />
                    <a href="tel:+012(345)678">+012 (345) 678</a>
                  </span>
                </div>
                <div className="menu-button">
                  <Link to="/contact">
                    <a className="main-btn btn-yellow">Get a Quote</a>
                  </Link>
                </div>
                <div className="bar-item">
                  <a className="c-pointer" onClick={() => togglePanel()}>
                    <img src="/assets/images/bar.png" alt="" />
                  </a>
                </div>
                <button
                  type="button"
                  className="navbar-toggler"
                  aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                  aria-expanded={mobileMenuOpen}
                  aria-controls="main-nav-menu"
                  onClick={onToggleMobileMenu}
                >
                  <span />
                  <span />
                  <span />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </Fragment>
);

const Header4 = ({ overlayPanel, togglePanel, mobileMenuOpen, onToggleMobileMenu, onCloseMobileMenu }) => (
  <Fragment>
    <OffcanvasPanel overlyPanel={overlayPanel} togglePanel={togglePanel} />
    <header className="header-area">
      <div className="header-top-bar top-bar-two dark-black-bg">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 col-md-12 col-6">
              <div className="top-bar-left d-flex align-items-center">
                {/* <span className="lang-dropdown">
                  <select className="wide">
                    <option value={1}>English</option>
                    <option value={2}>French</option>
                  </select>
                </span> */}
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12 col-6">
              <div className="top-bar-right">
                <span className="text">
                  <i className="far fa-clock" />
                  Opening Hours : Sunday- Friday, 08:00 am - 05:00pm
                </span>
                <ul className="social-link">
                  <li>
                    <a href="#" title="Facebook">
                      {/* <i className="fab fa-facebook-f" /> */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3" />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="#" title="X">
                      <i className="fab fa-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#" title="Linkedin">
                      <i className="fab fa-linkedin" />
                    </a>
                  </li>
                  <li>
                    <a href="#" title="Youtube">
                      <i className="fab fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="header-navigation navigation-four">
        <div
          className={`nav-overlay ${mobileMenuOpen ? "active" : ""}`}
          aria-hidden="true"
          onClick={onCloseMobileMenu}
        />
        <div className="container-fluid">
          <div className="primary-menu">
            <div className="site-branding">
              <Link to="/" className="brand-logo" aria-label="brand-logo">
                <img src="/assets/images/logo/logo-3.png" alt="Site Logo" />
              </Link>
              <Link to="/index-4">
                <a className="sticky-logo">
                  <img src="/assets/images/logo/logo-2.png" alt="Site Logo" />
                </a>
              </Link>
            </div>
            <div className="nav-inner-menu">
              <div className="bar-item">
                <a className="c-pointer" onClick={() => togglePanel()}>
                  <img src="/assets/images/bar-2.png" alt="" />
                </a>
              </div>
              <div className={`nav-menu ${mobileMenuOpen ? "menu-on" : ""}`} id="main-nav-menu" role="navigation" aria-label="Main">
                {/*=== Mobile Logo ===*/}
                <div className="mobile-logo mb-30 d-block d-xl-none text-center" onClick={onCloseMobileMenu}>
                  <Link to="/" className="brand-logo" aria-label="brand-logo">
                    <img src="/assets/images/logo/logo-1.png" alt="Site Logo" />
                  </Link>
                </div>
                {/*=== Navbar Call Button ===*/}
                <div className="call-button text-center">
                  <span>
                    <i className="far fa-phone" />
                    <a href="tel:+012(345)678">+012 (345) 678</a>
                  </span>
                </div>
                {/*=== Main Menu ===*/}
                <Menu />
                <MobileHeader />
                {/*=== Navbar Menu Button ===*/}
                <div className="menu-button">
                  <Link to="/contact">
                    <a className="main-btn bordered-btn">Get a Quote</a>
                  </Link>
                </div>
              </div>
              {/*=== Nav Right Item ===*/}
              <div className="nav-right-item d-flex align-items-center">
                <div className="call-button">
                  <span>
                    <i className="far fa-phone" />
                    <a href="tel:+012(345)678">+012 (345) 678</a>
                  </span>
                </div>
                <div className="menu-button">
                  <Link to="/contact">
                    <a className="main-btn bordered-btn bordered-yellow">
                      Get a Quote
                    </a>
                  </Link>
                </div>
                <button
                  type="button"
                  className="navbar-toggler"
                  aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                  aria-expanded={mobileMenuOpen}
                  aria-controls="main-nav-menu"
                  onClick={onToggleMobileMenu}
                >
                  <span />
                  <span />
                  <span />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </Fragment>
);

const DefaultHeader = ({ data, topBanner, isMobile, mobileMenuOpen, onToggleMobileMenu, onCloseMobileMenu }) => (
  <header className="header-area sticky">
    {topBanner && topBanner.enable && <Top data={topBanner} />}
    {/* Header Navigation */}
    <div className="header-navigation navigation-three">
      <div
        className={`nav-overlay ${mobileMenuOpen ? "active" : ""}`}
        aria-hidden="true"
        onClick={onCloseMobileMenu}
      />
      <div className="container-fluid">
        <div className="primary-menu">
          {/* Site Branding */}
          <div className="site-branding">
            <Link to="/" className="brand-logo" aria-label="brand-logo">
              <GatsbyImage
                image={data?.logo?.asset?.gatsbyImageData}
                alt={data?.data?.logo?.alt}
                loading="eager"
                priority
              />
            </Link>
            <Link to="/" className="sticky-logo">
              <GatsbyImage
                image={data?.logo2?.asset?.gatsbyImageData}
                alt={data?.data?.logo2?.alt}
                loading="eager"
                priority
              />
            </Link>
          </div>
          {/* Nav inner Menu */}
          <div className="nav-inner-menu">
            {/* Nav Menu */}
            <div
              className={`nav-menu ${mobileMenuOpen ? "menu-on" : ""}`}
              id="main-nav-menu"
              role="navigation"
              aria-label="Main"
            >
              {/*=== Mobile Logo ===*/}
              <div
                className="mobile-logo mb-30 d-block d-xl-none text-center"
                onClick={onCloseMobileMenu}
              >
                <Link to="/" className="brand-logo" aria-label="brand-logo">
                  <GatsbyImage
                    image={data?.logo2?.asset?.gatsbyImageData}
                    alt={data?.data?.logo2?.alt}
                    loading="eager"
                  />
                </Link>
              </div>
              {/*=== Navbar Call Button ===*/}
              {/* <div className="call-button text-center">
                <span>
                  <i className="far fa-phone" />
                  <a href={`tel:${data?.phone}`}>{data?.phone}</a>
                </span>
              </div> */}
              {/*=== Main Menu ===*/}

              {isMobile ? (
                <MobileHeader list={data?.menu} />
              ) : (
                <Menu list={data?.menu} />
              )}

              {/*=== Navbar Menu Button ===*/}
              <div className="menu-button">
                {data?.button?.title && (
                  <Button
                    text={data.button.title}
                    btnType={data?.button.btnType}
                    link={data?.button.link}
                    file={data?.button.file}
                    linkType={data?.button.linkType}
                  />
                )}
              </div>
            </div>
            {/*=== Nav Right Item ===*/}
            <div className="nav-right-item d-flex align-items-center">
              {/* <div className="call-button">
                <Link to="/cart">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="black"
                    class="bi bi-cart"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                </Link>
                 <span>
                  <i className="far fa-bag" />
                  <a href={`tel:${data?.phone}`}>{data?.phone}</a>
                </span> 
              </div> */}
              <div className="menu-button">
                {data?.button?.title && (
                  <Button
                    text={data.button.title}
                    btnType={data?.button.btnType}
                    link={data?.button.link}
                    file={data?.button.file}
                    linkType={data?.button.linkType}
                  />
                )}
              </div>
              {/* <div className="bar-item">
                <a href="#">
                  <img src="/assets/images/bar.png" alt="" />
                </a>
              </div> */}
              <button
                type="button"
                className="navbar-toggler"
                aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                aria-expanded={mobileMenuOpen}
                aria-controls="main-nav-menu"
                onClick={onToggleMobileMenu}
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
);
